// Copyright 2019 Sorama B.V.

import { PLATFORM } from "aurelia-framework";
import {
    IWorkflowModuleConfig,
    WorkflowModuleType,
} from "libraries/WorkflowFramework/Interfaces/IWorkflowModuleConfig";
import { MeasurementSetupGuidanceCatalog } from "./../GuidanceCatalog/MeasurementSetupGuidanceCatalog";

export class MeasurementSetupWorkflowModuleCatalog {
    static MeasurementSetupsModule: IWorkflowModuleConfig = {
        name: "measurementsetups",
        modulePath: PLATFORM.moduleName("modules/workflows/MeasurementSetup/MeasurementSetups/MeasurementSetupsModule"),
        title: "Measurement Setups",
        moduleType: WorkflowModuleType.MeasurementSetup,
        help: MeasurementSetupGuidanceCatalog.MeasurementSetupMS1Module,
        requireOnline: true,
        requireSignIn: true,
        isInadmissible: true,
    };

    static MeasurementSetupModule: IWorkflowModuleConfig = {
        name: "measurementsetup",
        modulePath: PLATFORM.moduleName("modules/workflows/MeasurementSetup/MeasurementSetup/MeasurementSetupModule"),
        title: "Measurement Setup",
        moduleType: WorkflowModuleType.MeasurementSetup,
        requireOnline: true,
        requireSignIn: true,
        isInadmissible: true,
    };

    static MeasurementDeviceModule: IWorkflowModuleConfig = {
        name: "measurementdevice",
        modulePath: PLATFORM.moduleName("modules/workflows/MeasurementSetup/MeasurementDevice/MeasurementDeviceModule"),
        title: "Measurement Device",
        moduleType: WorkflowModuleType.MeasurementSetup,
        requireOnline: true,
        requireSignIn: true,
        isInadmissible: true,
    };
}
